import * as React from 'react';
import { useSelector } from 'react-redux';

import { getListingAgencies, getListingRealtors, setSortByAgencies, setSortByRealtors } from '../../../actions/filters';

import { SortFilter } from '../../../components/SortFilter';
import { sorts } from '../../../constants/filters';
import { getSort } from '../../../selectors/filters';
import { getTotalCount } from '../../../selectors/listing';
import { getCurrentTab } from '../../../selectors/tabs';
import { ESortFilter } from '../../../types/redux/filters';
import { ETabs } from '../../../types/redux/tabs';
import { trackSortClick } from './tracking/trackSortClick';
import { useAppDispatch } from '../../../hooks/useAppDispatch/useAppDispatch';

export function SortFilterContainer() {
  const dispatch = useAppDispatch();

  const totalCountItems = useSelector(getTotalCount);
  const activeValue = useSelector(getSort);
  const currentTab = useSelector(getCurrentTab);

  const onChangeSort = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (sort: any) => {
      const isRealtorsListing = currentTab === ETabs.Realtors;
      const getListing = isRealtorsListing ? getListingRealtors : getListingAgencies;
      const setNewSort = isRealtorsListing ? setSortByRealtors : setSortByAgencies;
      const correctSortValue = sort === ESortFilter.Any ? undefined : sort;
      dispatch(getListing(setNewSort, correctSortValue));
      trackSortClick();
    },
    [currentTab, dispatch],
  );

  if (!totalCountItems) {
    return null;
  }

  return <SortFilter activeValue={activeValue} onChange={onChangeSort} options={sorts} />;
}
